import React from 'react';
import TermsandConditions from './TermsandConditions';
import Footer from './common/Footer';
import Header from './common/Header';

const TandCNotProtected: React.FC = () => {
  return (
    <div className="layout-container">
      <header className="root-header">
        <Header />
      </header>
      <main className="layout-content custom-margin col-lg-8 col-md-12 col-sm-12">
        <div className="common-background">
          <TermsandConditions />
        </div>
      </main>
      <footer className="root-footer row justify-content-center p-0 g-0">
        <Footer />
      </footer>
    </div>
  );
};

export default TandCNotProtected;
